import { Component, OnInit, inject } from '@angular/core'
import { User } from '../../../models/user'
import { AuthService } from '../../../services/auth.service'
import { SwPush } from '@angular/service-worker'
import { NotificationService } from '../../../services/notification.service'
import { OAuthService } from 'angular-oauth2-oidc'
import { RouterLink } from '@angular/router';
import { NgbDropdown, NgbDropdownToggle, NgbDropdownMenu, NgbDropdownButtonItem, NgbDropdownItem } from '@ng-bootstrap/ng-bootstrap/dropdown';

@Component({
    selector: 'lg-navbar-main',
    templateUrl: './navbar-main.component.html',
    styleUrls: ['./navbar-main.component.scss'],
    imports: [RouterLink, NgbDropdown, NgbDropdownToggle, NgbDropdownMenu, NgbDropdownButtonItem, NgbDropdownItem]
})
export class NavbarMainComponent implements OnInit {
  authService = inject(AuthService);
  private notificationService = inject(NotificationService);
  swPush = inject(SwPush);

  user: User
  chantierCode: string

  constructor() {
    const swPush = this.swPush;

    ;(window as any).swPush = swPush
  }

  ngOnInit(): void {
    this.user = this.authService.connectedUser
    if (this.user) {
      this.requestAndStoreSubscription()
    }
  }

  requestAndStoreSubscription() {
    if (!this.swPush.isEnabled) {
      console.warn('Notifications non disponibles : les service workers sont désactivés ou non supportés.')
      return
    }

    this.swPush
      .requestSubscription({ serverPublicKey: this.user.vapidPublicKey })
      .then((pushSubscription) => {
        this.notificationService.storeSubscription(pushSubscription).subscribe()
      })
      .catch((err) => console.error('Could not subscribe to notifications', err))
  }
}
